import loadable from '@loadable/component';

export const CmsListingCountsLoadable = loadable(
  () => import('./CmsListingCounts'),
  { resolveComponent: (module) => module.CmsListingCounts },
);
